module.exports = __webpack_public_path__ + "files/454308d3261c0247c8e52d6267022806.png";